export enum FeatureFlagNames {
  BLOCKED_BEER = 'BlockedBeer',
  BREWHOUSE_UNITS_PREFERENCE = 'BrewhouseUnitsPreference',
  CDC_STREAMING_MANAGEMENT = 'CdcStreamingManagement',
  ENABLE_LOGOUT_FOR_HOP_RECIPE_VIEWER = 'EnableLogoutForHopRecipeViewer',
  HOPS_LOT_NUMBER_CROP_YEAR_CHANGE = 'HopsLotNumberCropYearChange',
  KPI_CALCULATOR = 'Data Management Portal',
  KPI_TREE = 'KpiTree',
  LOT_NUMBER_SINGLE_BRAND = 'Lot_Number_Single_Brand',
  SUPPLY_DATA_MANAGEMENT_PORTAL = 'PolkaDots',
  VIEW_ASSIGN_ACTIVE_LOT_NUMBERS = 'ViewAssignActiveLotNumbers',
  URGENT_SPECIALS = 'UrgentSpecials',
  USE_NEW_AUDIT_LOGS_LOGIC = 'UseNewAuditLogsLogic'
}
